import 'css-chunk:src/AppInit.module.scss';export default {
  "root": "_root_12chu_1"
};